import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-56c94251"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "appBox__outside"
};
const _hoisted_2 = ["onContextmenu", "onClick"];
const _hoisted_3 = {
  class: "appBox__outside__item__tooltip"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "appBox__outside__item__hoverName"
};
const _hoisted_6 = {
  class: "appBox__inside"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 应用 ", -1));

const _hoisted_8 = {
  class: "popover__boxDisplay"
};
const _hoisted_9 = {
  class: "popover__boxDisplay__up"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "popoverList__title"
}, "全部应用", -1));

const _hoisted_11 = {
  key: 1,
  class: "noAppText"
};
const _hoisted_12 = {
  key: 0,
  class: "appAddButton"
};
const _hoisted_13 = {
  class: "add-icon__label"
};
import { NImage, NSpace, NPopover, NDivider, NTree, NScrollbar, NTooltip } from 'naive-ui';
import { computed, onMounted, ref, watch, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useResizeObserver, useElementBounding, useWindowSize } from '@vueuse/core';
import defaultAppIcon from '../../../../assets/defaultAppIcon.svg';
import createNewAppLink from '../../../../assets/createNewAppLink.svg';
import Icon from '@teams/common/components/icon';
import useNavApplication from '../../useNavApplication';
import Draggable from 'vuedraggable';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      visibleAppList,
      // gotoCreatApp,
      creatAppByLink,
      showAppAdd,
      showAppModule,
      showAppOptions,
      openAppLink,
      onAppListOrderChange,
      changeApplistOrder,
      appSortable,
      isAllowDrop,
      isDraggling,
      dragend,
      dragstart,
      renderLabel
    } = useNavApplication();
    const outsideList = computed(() => {
      return visibleAppList.value.slice(0, maxOutSideNum.value);
    });
    const popoverListRef = ref(null); // 元素到界面顶部的距离,计算滚动内容的高度

    const {
      top
    } = useElementBounding(popoverListRef);
    const {
      height
    } = useWindowSize();
    const elementMaxHeight = computed(() => {
      return height.value - top.value - 100;
    });
    const appBoxInsideRef = ref(null);
    const showPopover = ref(false);
    const appBoxWidth = ref(0);
    const maxOutSideNum = ref(0);
    const appBoxRef = ref(null);
    useResizeObserver(appBoxRef, entries => {
      const entry = entries[0];
      const {
        width
      } = entry.contentRect;
      appBoxWidth.value = width;
    });
    watch([() => appBoxWidth.value], () => {
      const addIconWidth = 32;
      const elementWidth = 36;

      if (appBoxWidth.value < addIconWidth + elementWidth) {
        maxOutSideNum.value = 0;
      } else if (appBoxWidth.value < addIconWidth + elementWidth * 2) {
        maxOutSideNum.value = 1;
      } else if (appBoxWidth.value < addIconWidth + elementWidth * 3) {
        maxOutSideNum.value = 2;
      } else if (appBoxWidth.value < addIconWidth + elementWidth * 4) {
        maxOutSideNum.value = 3;
      } else {
        maxOutSideNum.value = 4;
      }
    });
    const {
      t
    } = useI18n(); // eslint-disable-next-line

    const $tt = (key, ...params) => {
      // @ts-ignore
      return t(`components.navigator.navs.${key}`, ...params);
    };

    const changeClickStyle = () => {
      showPopover.value = !showPopover.value;
    };

    const openAddAppDialog = () => {
      showPopover.value = false;
      creatAppByLink(); // 应用市场还未修改好，界面上不展示
      // gotoCreatApp(e)
    };

    const closePop = e => {
      const className = e.target.className;

      if (className !== '') {
        showPopover.value = false;
      }
    };

    const handleKeyBoard = e => {
      if (e.key === 'Escape') {
        showPopover.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener('keydown', handleKeyBoard);
    });
    onUnmounted(() => {
      document.removeEventListener('keydown', handleKeyBoard);
    });
    return (_ctx, _cache) => {
      const _component_n_button = _resolveComponent("n-button");

      return _unref(showAppModule) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "appBox",
        ref_key: "appBoxRef",
        ref: appBoxRef
      }, [_createVNode(_unref(NSpace), {
        justify: "end",
        inline: true,
        align: 'center',
        wrap: false,
        size: 4
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(Draggable), {
          class: "outside__dragBox",
          disabled: !_unref(appSortable),
          list: _unref(outsideList),
          "ghost-class": "ghostClass",
          "chosen-class": "chosenClass",
          "item-key": "appId",
          animation: "300",
          onStart: _unref(dragstart),
          onEnd: _unref(dragend),
          onChange: _unref(onAppListOrderChange)
        }, {
          item: _withCtx(({
            element
          }) => [_createElementVNode("div", {
            class: "appBox__outside__item",
            onContextmenu: _withModifiers(e => _unref(showAppOptions)(e, element), ["prevent", "stop"]),
            onClick: $event => _unref(openAppLink)(element.appLink)
          }, [_createVNode(_unref(NTooltip), {
            trigger: "hover",
            placement: "bottom-start",
            disabled: _unref(isDraggling)
          }, {
            trigger: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
              class: "appBox__outside__item__tooltip__img",
              width: "16",
              src: element.appIcon || _unref(defaultAppIcon),
              "preview-disabled": ""
            }, null, 8, _hoisted_4)])]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(element.appName), 1)]),
            _: 2
          }, 1032, ["disabled"])], 40, _hoisted_2)]),
          _: 1
        }, 8, ["disabled", "list", "onStart", "onEnd", "onChange"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(NPopover), {
          trigger: "manual",
          show: showPopover.value,
          "show-arrow": false,
          placement: "bottom-end",
          class: "appBox__inside__popoverBox",
          onClickoutside: closePop
        }, {
          trigger: _withCtx(() => [_createVNode(_unref(NTooltip), {
            trigger: "hover",
            placement: "bottom-start"
          }, {
            trigger: _withCtx(() => [_createVNode(_component_n_button, {
              text: "",
              type: "error",
              class: _normalizeClass(['createNewAppLinkIcon', {
                'tooltip-open': showPopover.value
              }]),
              onClick: changeClickStyle
            }, {
              icon: _withCtx(() => [_createVNode(_unref(NImage), {
                width: "16",
                src: _unref(createNewAppLink),
                "preview-disabled": ""
              }, null, 8, ["src"])]),
              _: 1
            }, 8, ["class"])]),
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "appBox__inside__popover",
            ref_key: "appBoxInsideRef",
            ref: appBoxInsideRef
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_unref(visibleAppList) && _unref(visibleAppList).length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "popoverListRef",
            ref: popoverListRef,
            class: "popoverList"
          }, [_hoisted_10, _createVNode(_unref(NScrollbar), {
            style: _normalizeStyle(`max-height: ${_unref(elementMaxHeight)}px;padding-right:4px`)
          }, {
            default: _withCtx(() => [_createVNode(_unref(NTree), {
              "block-line": "",
              draggable: _unref(appSortable),
              "key-field": "appId",
              data: _unref(visibleAppList),
              "render-label": e => _unref(renderLabel)(e, 'horizontal'),
              onDrop: _unref(changeApplistOrder),
              onDragend: _unref(dragend),
              onDragstart: _unref(dragstart),
              "allow-drop": _unref(isAllowDrop)
            }, null, 8, ["draggable", "data", "render-label", "onDrop", "onDragend", "onDragstart", "allow-drop"])]),
            _: 1
          }, 8, ["style"])], 512)) : (_openBlock(), _createElementBlock("div", _hoisted_11, " 可将团队成员常用的「应用」添加到此，以便快速启动 "))]), _unref(showAppAdd) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_unref(NDivider), {
            class: "appAddButton__divider"
          }), _createElementVNode("div", {
            class: "addButton",
            onClick: _cache[0] || (_cache[0] = () => openAddAppDialog()),
            ref: "addNavRef"
          }, [_createVNode(_unref(Icon), {
            name: "addNav",
            fill: "transparent",
            size: 20
          }), _createElementVNode("span", _hoisted_13, _toDisplayString($tt('addApp')), 1)], 512)])) : _createCommentVNode("", true)])], 512)]),
          _: 1
        }, 8, ["show"])])]),
        _: 1
      })], 512)) : _createCommentVNode("", true);
    };
  }

});